import LucideGlyph from 'lucide-react/dist/esm/icons/chevron-down.mjs';
import type { JSX } from 'react';
import { Icon } from '../../Icon/Icon.js';
import type { IconProps } from '../../Icon/Icon.js';

export function NavigationChevronDownIcon(props: IconProps): JSX.Element {
  return <Icon glyph={LucideGlyph} size={24} fillable={false} {...props} />;
}
